import React from 'react'
import { UseFormMethods } from "react-hook-form"
import { FormulaireSchemaType } from "../../../lib/formulaireContext/validation/formulaire.schema"
import { FormTextField } from '../Fields/FormTextField';
import { Paper, Typography, Grid } from '@material-ui/core';

type FieldConfig = {
    name: string;
    label: string;
    readOnly?: boolean;
    required?: boolean;
    helperText?: string;
}

const declarantFields: FieldConfig[] = [
    { name: "declarant.id", label: "ID", required: true, readOnly: true },
    { name: "declarant.last_edition_date", label: "Date", required: true, readOnly: true },
    { name: "declarant.first_name", label: "Prénom", required: true, readOnly: true },
    { name: "declarant.last_name", label: "Nom", required: true, readOnly: true },
    { name: "declarant.company_name", label: "Société", required: true, readOnly: true },
]

export const DeclarantSection = ({ form }: { form: UseFormMethods<FormulaireSchemaType> }) => {
    const { control, formState } = form
    return (
        <Paper elevation={2} style={{ padding: 18, marginBottom: 26, marginTop: 26 }}>
            <Typography variant="h5" component="h2" gutterBottom>
                Déclarant
            </Typography>

            <Grid container spacing={3}>
                {declarantFields.map((field) => (
                    <Grid item xs={12} sm={6} key={field.name}>
                        <FormTextField
                            label={field.label}
                            name={field.name}
                            control={control}
                            disabled={field.readOnly}
                            required={field.required}
                            formState={formState}
                            helperText={field.helperText}
                        />
                    </Grid>
                ))}
            </Grid>
        </Paper>
    )
}
